import React from 'react';
import SetName from './SetName';

export default class SettingsPage extends React.Component {
  render () {
    return (
      <div className="c-settings-page">
        <SetName/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SettingsPage/SettingsPage.js